/*------------------------------------*\
	#CALCULATOR FLAG
\*------------------------------------*/

import 'waypoints/lib/noframework.waypoints.min';

/*
 * [1] this fixes a glitch that sometimes happens when the is-fixed class is set before the transition ends
 * [2] this is a variable value for setting up the offset of the calculator 0 means the bottom of the element reaches the top off the viewport
 * [3] to get a right value from the waypoint calculation we need to observe the lyngtech web component
 */

const config = {childList: true, subtree: true},
	observer = new MutationObserver(checkCalculatorHeightChange);

function initCalculatorFlag() {
	const stageCalculatorWithFlag = document.getElementById('calculator-stage-with-flag'),
		calculatorFlag = document.querySelector('.js-calculator-flag'),
		calculatorFlagButton = document.querySelector('.js-calculator-flag-button'),
		stageCalculatorButtonClose = document.querySelector('.js-calculator-button-close'),
		calculatorFlagTop = document.querySelector('.js-calculator-flag-position-top'),
		header = document.querySelector('.js-header'),
		breakpointTablet = 1024,
		offsetSpacing = 24;

	if (header) {
		const headerHeight = header.offsetHeight
		let stageCalculatorBox = '';

		if (stageCalculatorWithFlag) {
			stageCalculatorBox = stageCalculatorWithFlag.querySelector('.js-calculator-box');

			new Waypoint({
				element: stageCalculatorWithFlag,
				handler: function (direction) {
					if (direction === 'up') {
						stageCalculatorBox.classList.remove('is-fixed');
						stageCalculatorButtonClose.classList.remove('is-visible');

						stageCalculatorBox.classList.remove('is-hidden');
						calculatorFlag.classList.add('is-hidden');
						stageCalculatorBox.removeAttribute('style');

					} else {
						stageCalculatorBox.classList.add('is-hidden');
						calculatorFlag.classList.remove('is-hidden');

						setTimeout(function () { // [1]
							stageCalculatorBox.classList.add('is-fixed');
							stageCalculatorButtonClose.classList.add('is-visible');
							stageCalculatorBox.style.top = (headerHeight + offsetSpacing) + 'px';

							if (calculatorFlagTop) {
								calculatorFlagTop.style.top = (headerHeight + offsetSpacing) + 'px';
							} else {
								calculatorFlag.style.top = stageCalculatorBox.offsetTop + stageCalculatorBox.offsetHeight - calculatorFlag.offsetHeight + 'px';
							}
						}, 450);

					}

				},
				offset: function () {
					let visibleCalculatorPart = 100; // [2]

					return (-stageCalculatorWithFlag.offsetHeight + visibleCalculatorPart);
				}

			});

		}

		if (calculatorFlag) {
			calculatorFlag.addEventListener('click', () => {
				if (stageCalculatorBox) {
					let boxIsHidden = stageCalculatorBox.classList.contains('is-hidden');

					if (boxIsHidden) {
						stageCalculatorBox.classList.remove('is-hidden');
						calculatorFlagButton.classList.add('is-open');

						observer.disconnect();
					} else {
						stageCalculatorBox.classList.add('is-hidden');
						calculatorFlagButton.classList.remove('is-open');
						activateObserving();
					}

				}

			});

		}

		if (stageCalculatorButtonClose) {
			stageCalculatorButtonClose.addEventListener('click', () => {
				stageCalculatorBox.classList.add('is-hidden');
				calculatorFlagButton.classList.remove('is-open');
				activateObserving();
			});

		}

		if (window.innerWidth > breakpointTablet) {
			window.addEventListener('scroll', () => {
				if (stageCalculatorBox) {
					let boxIsFixed = stageCalculatorBox.classList.contains('is-fixed'),
						boxIsHidden = stageCalculatorBox.classList.contains('is-hidden');

					if (boxIsFixed && !boxIsHidden) {
						stageCalculatorBox.classList.add('is-hidden');
						calculatorFlagButton.classList.remove('is-open');
						activateObserving();
					}

				}

			});

		}
	}
}

function activateObserving() {
	const stageCalculatorBox = document.querySelector('#calculator-stage-with-flag .js-calculator-box'),
		stageCalculatorWithFlag = document.getElementById('calculator-stage-with-flag');

	stageCalculatorWithFlag.style.height = stageCalculatorBox.offsetHeight + 'px'; // [3]
	observer.observe(stageCalculatorWithFlag, config);
}

function checkCalculatorHeightChange(mutationsList, observer) {
	const stageCalculatorWithFlag = document.getElementById('calculator-stage-with-flag');
	stageCalculatorWithFlag.removeAttribute('style');

	mutationsList.forEach(function (mutation) {
		if (mutation.type === 'childList') {
			const currentHeight = stageCalculatorWithFlag.offsetHeight;

			if (currentHeight !== observer.previousHeight) {
				observer.previousHeight = currentHeight;
				stageCalculatorWithFlag.style.height = currentHeight + 'px';
			}

		}

	});

}

function initContentCalculator() {
	const contentCalculator = document.getElementById('calculator-content');

	if (contentCalculator) {
		const contentCalculatorBox = contentCalculator.querySelector('.js-calculator-box'),
			stageCalculatorWithFlag = document.getElementById('calculator-stage-with-flag');

		if (contentCalculator && stageCalculatorWithFlag && contentCalculatorBox) {
			contentCalculatorBox.classList.add('is-hidden');

			new Waypoint({
				element: contentCalculator,
				handler: function () {
					contentCalculatorBox.classList.toggle('is-hidden');
				},
				offset: '100%',
			})

		}

	}

}

document.addEventListener("DOMContentLoaded", function (event) {
	const stageCalculatorWithFlag = document.getElementById('calculator-stage-with-flag');

	if (stageCalculatorWithFlag) {

		observer.previousHeight = stageCalculatorWithFlag.offsetHeight;
		observer.observe(stageCalculatorWithFlag, config);
	}

	initCalculatorFlag(event);
	initContentCalculator(event);
});
